"use strict";
/*!
 *
 *  shuffle.ts
 *
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (arr) {
    var _a;
    var newArr = __spreadArray([], arr, true);
    for (var i = newArr.length; 1 < i; i--) {
        var j = Math.floor(Math.random() * i);
        _a = [newArr[i - 1], newArr[j]], newArr[j] = _a[0], newArr[i - 1] = _a[1];
    }
    ;
    return newArr;
});
